<footer style="text-align: center;">
  <hr>
  <a href="https://www.yubilly.com">
    <p><img src="assets/yubilly-logo.png" alt="Yubilly Logo" height="40px">© {{'copyright' | translate}}</p>
  </a>
</footer>
